export var FilterTypes;
(function (FilterTypes) {
    FilterTypes["Customer"] = "customer";
    FilterTypes["Channel"] = "channel";
    FilterTypes["Agent"] = "agent";
    FilterTypes["Team"] = "team";
    FilterTypes["Tag"] = "tag";
    FilterTypes["TicketId"] = "ticketId";
    FilterTypes["Status"] = "status";
    FilterTypes["Date"] = "date";
    FilterTypes["Time"] = "time";
    FilterTypes["ReturnFlowName"] = "returnFlowName";
    FilterTypes["TemplateName"] = "templateName";
})(FilterTypes || (FilterTypes = {}));
